export const GOOGLE_ANALYTICS_ID = {
  prod: 'UA-5784146-56',
  dev: 'UA-5784146-57',
};



// WEBPACK FOOTER //
// ./src/config/ga.js